import { Link } from "react-router-dom";
import { ReactTyped } from "react-typed";
import { IconCategory, IconClipboardText, IconExchange, IconHistory, IconInfoCircle, IconPackage, IconReport, IconTag, IconUsers } from "@tabler/icons-react";
import SymbolBlueBackground from "../Assets/Images/SymbolBlueBackground.svg";

import StockIllustration from "./../Assets/Illustrations/Stock.svg";
import CustomerIllustration from "./../Assets/Illustrations/Customer.svg";
import SupplierIllustration from "./../Assets/Illustrations/Supplier.svg";

export default function IndexPage() {
    return (
        <>
            <header className="hero">
                <div className="container">
                    <div className="row g-lg-8 align-items-center">
                        <div className="col-md-7 text-center text-md-start">
                            <div className="hero-subheader">LineXS</div>
                            <h1 className="hero-title text-nowrap">
                                Tudo o que você precisa para
                                <br />
                                <ReactTyped
                                    loop
                                    className="text-primary text-nowrap"
                                    strings={["administrar sua empresa,", "otimizar seus processos,", "gerenciar seu negócio,"]}
                                    typeSpeed={30}
                                    backSpeed={50}
                                    backDelay={1500}
                                />
                                <br />
                                em um só lugar.
                            </h1>
                            <p className="hero-description mt-4 ms-0" style={{ fontSize: "1rem" }}>
                                Simplicidade, eficiência e controle completo para micro e médias
                                empresas.
                            </p>
                            <div className="mt-6 mt-lg-7">
                                <div className="row justify-content-center justify-content-md-start">
                                    <div className="col-auto">
                                        <a href="#" className="btn btn-lg btn-primary">
                                            Experimente Grátis
                                        </a>
                                    </div>
                                    <div className="col-auto">
                                        <Link className="btn btn-lg" to={"/planos"}>
                                            Planos
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md d-none d-lg-block">
                            <div className="hero-img-side">
                                <img
                                    className="rounded-circle"
                                    src={SymbolBlueBackground}
                                    style={{
                                        height: 336,
                                        boxShadow:
                                            "0 10px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <section className="section section-light mt-5 py-5 mb-5">
                <svg className="section-divider" xmlns="http://www.w3.org/2000/svg" viewBox="0 24 150 28" preserveAspectRatio="none">
                    <path className="wave-1" d="M-110 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
                    <path className="wave-2" d="M-110 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
                    <path className="wave-3" d="M-110 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
                </svg>
            </section>

            <div className="hero">
                <div className="container">
                    <h1 className="hero-title"><strong className="text-primary">Sistema de ERP</strong> Simples e Prático</h1>
                    <p className="hero-description hero-description-wide">
                        É um sistema de gestão para controle financeiro da sua empresa em único lugar.
                    </p>
                </div>
            </div>


            <ProductFeatureHero />
            <CustomerFeatureHero />
            <SupplierFeatureHero />

        </>
    )
}

function ProductFeatureHero() {
    return (
        <section className="section">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Gestão completa de produtos</h2>
                    <div className="section-description">
                        Organize, controle e otimize o ciclo de vida dos seus produtos de forma simples e eficiente.
                        Nosso ERP garante que você tenha total visibilidade desde o cadastro até o controle de estoque e fornecedores.
                    </div>
                </div>

                <div className="row g-lg-6 align-items-center">
                    <div className="col-lg-6 mb-3 mb-lg-0">
                        <img src={StockIllustration} className="img-fluid" alt="Imagem de controle de estoque" />
                    </div>

                    <div className="col-lg-6">
                        <div className="space-y-6">

                            <div className="row">
                                <div className="col-auto">
                                    <div className="shape shape-md">
                                        <IconClipboardText className="icon" />
                                    </div>
                                </div>
                                <div className="col">
                                    <h3 className="h2 mb-2">Gestão simplificada</h3>
                                    <p className="text-secondary m-0">
                                        Cadastre e acompanhe todos os seus produtos em um único lugar,
                                        com informações claras e acessíveis para sua equipe.
                                    </p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-auto">
                                    <div className="shape shape-md">
                                        <IconTag className="icon" />
                                    </div>
                                </div>
                                <div className="col">
                                    <h3 className="h2 mb-2">Categorização e Segmentação</h3>
                                    <p className="text-secondary m-0">
                                        Organize seus itens em categorias e marcas para facilitar a busca,
                                        a análise e a tomada de decisão estratégica.
                                    </p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-auto">
                                    <div className="shape shape-md">
                                        <IconPackage className="icon" />
                                    </div>
                                </div>
                                <div className="col">
                                    <h3 className="h2 mb-2">Controle de Estoque</h3>
                                    <p className="text-secondary m-0">
                                        Tenha visibilidade em tempo real dos níveis de estoque,
                                        evite rupturas e reduza custos com excesso de mercadorias.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}


function CustomerFeatureHero() {
    return (
        <section className="section section-light">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Gestão completa de clientes</h2>
                    <div className="section-description">
                        Mantenha todos os dados dos seus clientes organizados, acompanhe interações e fortaleça o relacionamento com informações centralizadas.
                    </div>
                </div>

                <div className="row g-lg-6 align-items-center">

                    <div className="col-lg-6">
                        <div className="space-y-6">

                            <div className="row">
                                <div className="col-auto">
                                    <div className="shape shape-md">
                                        <IconUsers className="icon" />
                                    </div>
                                </div>
                                <div className="col">
                                    <h3 className="h2 mb-2">Centralização de informações</h3>
                                    <p className="text-secondary m-0">
                                        Armazene dados de contato, histórico de interações e documentos importantes, tudo em um único lugar.
                                    </p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-auto">
                                    <div className="shape shape-md">
                                        <IconTag className="icon" />
                                    </div>
                                </div>
                                <div className="col">
                                    <h3 className="h2 mb-2">Segmentação inteligente</h3>
                                    <p className="text-secondary m-0">
                                        Classifique seus clientes por categorias, segmento ou comportamento, facilitando ações de marketing e atendimento personalizado.
                                    </p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-auto">
                                    <div className="shape shape-md">
                                        <IconExchange className="icon" />
                                    </div>
                                </div>
                                <div className="col">
                                    <h3 className="h2 mb-2">Acompanhamento de interações</h3>
                                    <p className="text-secondary m-0">
                                        Monitore negociações, propostas e atendimentos de forma clara, garantindo um relacionamento de qualidade e fidelização.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="col-lg-6 mb-3 mb-lg-0">
                        <img src={CustomerIllustration} className="img-fluid" alt="Imagem de clientes" />
                    </div>

                </div>
            </div>
        </section>
    )
}


function SupplierFeatureHero() {
    return (
        <section className="section">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Gestão eficiente de fornecedores</h2>
                    <div className="section-description">
                        Organize informações, acompanhe negociações e tenha controle total sobre seus fornecedores em um único lugar.
                    </div>
                </div>

                <div className="row g-lg-6 align-items-center">
                    <div className="col-lg-6 mb-3 mb-lg-0">
                        <img src={SupplierIllustration} className="img-fluid" alt="Imagem de fornecedores" />
                    </div>

                    <div className="col-lg-6">
                        <div className="space-y-6">

                            <div className="row">
                                <div className="col-auto">
                                    <div className="shape shape-md">
                                        <IconInfoCircle className="icon" />
                                    </div>
                                </div>
                                <div className="col">
                                    <h3 className="h2 mb-2">Cadastro completo</h3>
                                    <p className="text-secondary m-0">
                                        Armazene todos os dados de contato, documentos e informações comerciais de seus fornecedores de forma centralizada.
                                    </p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-auto">
                                    <div className="shape shape-md">
                                        <IconHistory className="icon" />
                                    </div>
                                </div>
                                <div className="col">
                                    <h3 className="h2 mb-2">Histórico de negociações</h3>
                                    <p className="text-secondary m-0">
                                        Acompanhe pedidos, contratos e condições comerciais, garantindo decisões mais estratégicas e negociações mais eficientes.
                                    </p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-auto">
                                    <div className="shape shape-md">
                                        <IconTag className="icon" />
                                    </div>
                                </div>
                                <div className="col">
                                    <h3 className="h2 mb-2">Segmentação e classificação</h3>
                                    <p className="text-secondary m-0">
                                        Organize seus fornecedores por categoria, segmento ou prioridade, facilitando o controle e a análise estratégica.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
